import velocity from 'velocity-animate';
import $ from 'jquery';
import { Power1, Power0, Power4, TimelineMax } from "gsap/TweenMax";


export default () => {

  var scrollpos;
  var url_default = $('.header__logo').attr('data-url-default');
  var url_collapsed = $('.header__logo').attr('data-url-collapsed');
  var layerOpen = false;
  $('#toggle').click(function () {
    var $that = $(this);
    //open
    //scrollpos = $(window).scrollTop();
    //$('body').addClass('body-fixed');

    //close
    //$('body').removeClass('body-fixed');
    //$('html, body').scrollTop(scrollpos);

    if (layerOpen == true) {

      $('body').removeClass('body-fixed');
      $('html, body').animate({
        scrollTop: scrollpos
      }, 100, 'linear', function () {
        $that.removeClass('active');
        $('#overlay').removeClass('open');
        $('header').removeClass('overlay-open');

        if ($('header').attr('class').indexOf('collapsed') !== -1) {
          $('.header__logo').attr('src', url_collapsed);
        }
        else {
          $('.header__logo').attr('src', url_default);
        }
      });


    } else {

      $that.addClass('active');
      $('#overlay').addClass('open');
      $('header').addClass('overlay-open');


      $('.header__logo').attr('src', url_collapsed);

      setTimeout(function () {
        scrollpos = $(window).scrollTop();
        $('body').addClass('body-fixed');
      }, 300);

    }

    layerOpen = !layerOpen;


  });

  $('#mega-menu-mobile').find('a.nav-link').on('click', function (e) {
    e = e || window.event;
    e.stopImmediatePropagation();
  });
};



// WEBPACK FOOTER //
// ./scripts/libs/toggle-menu.js